(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name crewing.controller:CrewingRightPanelCtrl
     *
     * @description
     *
     */
    angular
        .module('crewing')
        .controller('CrewingRightPanelCtrl', CrewingRightPanelCtrl);

    function CrewingRightPanelCtrl($scope, EventManagerService, SlideInPanelService, CrewingHelper, MessageService, CommonMasterData, PopupManager) {
        var _panelName = 'crewing.right.panel';
        $scope.model = {
            blockDetails: SlideInPanelService.getData(_panelName),
            trainingPrograms: null,
            trainingProgramDetails: null,
            selectedTrainingProgram: null,
            selectedTrainingProgramDetails: null,
            selectedPic: null,
            selectedFlightLegId: null,
            selectedTrainingSlotId: null,
            selectedCrewProfileId: null,
            selectedCrewId: null,
            selectedCrewRole: null,
            selectedResult: null,
            selectedModule: null,
            isExpiryUpdatable: false,
            allModules: [],
            allCourses: [],
            crewRoleCol: [],
            allResults: [{name: 'PASS'}, {name: 'FAIL'}],
            selectedCourse: null,
            isTrainingProgramDisable: false,
            isTrainerTraineeDisable: true,
            accordion: {
                first: {
                    isOpen: true
                },
                second: {
                    isOpen: false
                },
                third: {
                    isOpen: false
                }
            },
            remarks: null,
            validationNo: null,
            checkIntimeReset : false,
            checkInDateStr : null,
            checkInTimeStr : null,
            selectedCrewList :[],
            selectedCrew : null,
            trainingStartDate : null,
            crewProfileIds : [],
            selectedFlightLegIdList : [],
            showTrainingPassPanel : false,
            crewIds : [],
            crewHubs : []
        };

        EventManagerService.registerEventListener(EventManagerService.EVENT.PANEL.DATA_CHANGED, onPanelDataChange);

        function onPanelDataChange(panelName) {
            if (panelName === _panelName) {
                $scope.model.blockDetails = SlideInPanelService.getData(_panelName);
                $scope.model.isTrainerTraineeDisable = true;
                $scope.model.isExpiryUpdatable = false;

                if ($scope.model.blockDetails.isTraining) {
                    $scope.model.selectedTrainingSlotId = $scope.model.selectedFlightLegId = $scope.model.blockDetails.adaptedFlightEventDetails &&
                        $scope.model.blockDetails.adaptedFlightEventDetails[0].id;
                    $scope.model.isTrainingProgramDisable = true;

                } else if(!!$scope.model.blockDetails.adaptedFlightEventDetails){
                    if( $scope.model.blockDetails.adaptedFlightEventDetails[0].type==='FLIGHT'){
                    	$scope.model.selectedFlightLegId = $scope.model.blockDetails.adaptedFlightEventDetails[0].id;
                    	$scope.model.isTrainingProgramDisable = false;

                    	populateFlightLegList();

                    }else if($scope.model.blockDetails.adaptedFlightEventDetails[0].type==='EVENT'){
                    	$scope.model.selectedEventId  = $scope.model.blockDetails.adaptedFlightEventDetails[0].id;
                    	$scope.model.isTrainingProgramDisable = true;
                    }
                }

                $scope.model.selectedCrewProfileId = $scope.model.blockDetails && $scope.model.blockDetails.adaptedAssignedCrewDetails &&
                    $scope.model.blockDetails.adaptedAssignedCrewDetails[0].crewProfileId;
                $scope.model.selectedCrewId = $scope.model.blockDetails && $scope.model.blockDetails.adaptedAssignedCrewDetails &&
                    $scope.model.blockDetails.adaptedAssignedCrewDetails[0].crewId;

                if (!!$scope.model.selectedFlightLegId || !!$scope.model.selectedTrainingSlotId) {
                    getTrainings();
                }
            }
        }

      function populateFlightLegList(){
        $scope.model.selectedFlightLegIdList = [];
        for(var i = 0;i<$scope.model.blockDetails.adaptedFlightEventDetails.length;i++){
          if($scope.model.blockDetails.adaptedFlightEventDetails[i].trainingPro != null){
            $scope.model.selectedFlightLegIdList.push($scope.model.blockDetails.adaptedFlightEventDetails[i].id);
          }
        }
      }

        $scope.onUpdateClick = function () {
        	var selectedFlightDetail = null;
        	if($scope.model.selectedFlightLegId !=null){
        		selectedFlightDetail = _.find($scope.model.blockDetails.adaptedFlightEventDetails, {id: $scope.model.selectedFlightLegId});
        	}

        	if(!!selectedFlightDetail){
        		var flightStartDateTime = selectedFlightDetail.startTime;
                var flightEndDateTiem = selectedFlightDetail.endTime;
                if (moment(flightStartDateTime, "DD/MM/YYYY HH:mm").isBefore(moment($scope.model.blockDetails.checkInDateStr + " " + $scope.model.blockDetails.checkInTimeStr, "DD/MM/YYYY HH:mm"))) {
                    MessageService.warning(MessageService.MESSAGES.CREWING.EDIT_BLOCK_ERROR_01);
                    return false;
                }
                else if (moment($scope.model.blockDetails.checkoutDateStr + " " + $scope.model.blockDetails.checkoutTimeStr, "DD/MM/YYYY HH:mm").isBefore(moment(flightEndDateTiem, "DD/MM/YYYY HH:mm"))) {
                    MessageService.warning(MessageService.MESSAGES.CREWING.EDIT_BLOCK_ERROR_02);
                    return false;
                }
                else {
                    onUpdate(false);
                }
        	}


        };

        $scope.onFlightClick = function (data) {
            $scope.model.isTrainerTraineeDisable = true;
            if(data.type === 'EVENT'){
            	$scope.model.selectedTrainingSlotId = null;
            	$scope.model.selectedFlightLegId = null;
            	$scope.model.selectedEventId = data.id;
            	$scope.model.selectedTrainingProgram = null;
            	$scope.model.isTrainingProgramDisable = true;
            	$scope.model.selectedTrainingProgramDetails = null;
            	$scope.model.selectedPic = null;
            }else {
            	if ($scope.model.blockDetails.isTraining) {
                    $scope.model.selectedTrainingSlotId = data.id;
                    $scope.model.selectedFlightLegId = null;
                } else {
                	$scope.model.selectedTrainingSlotId = null;
                    $scope.model.selectedFlightLegId = data.id;
                     updateSelectedFlightLegId(data.id)
                     data.trainingPro = null;
                }
            	$scope.model.isTrainingProgramDisable = false;
            	$scope.model.selectedEventId = null;
            	$scope.model.selectedTrainingProgram = _.find($scope.model.trainingPrograms, {trainingProgCode: data.trainingPro});
            	$scope.model.selectedPic = (data.pic =='Y' ? true : false);
            	$scope.model.selectedTrainingProgramDetails = null;
            	$scope.model.trainingStartDate = data.startTime;
            	getTrainingProgramDetails();
            }
            getTrainings();
            setTrainingCategoryForCrews();

        };

      function updateSelectedFlightLegId(id) {
        const index = $scope.model.selectedFlightLegIdList.indexOf(id);
        if (index !== -1) {
          $scope.model.selectedFlightLegIdList.splice(index, 1);
          $scope.model.selectedFlightLegId = $scope.model.selectedFlightLegIdList.length > 0 ? $scope.model.selectedFlightLegIdList[0] : null;
        } else {
          $scope.model.selectedFlightLegIdList.push(id);
        }
      }

        $scope.onCrewClick = function (crewProfileId,crew) {
            $scope.model.selectedCrewProfileId = crewProfileId;
            $scope.model.selectedCrewId = crew.crewId;
            $scope.model.selectedCrew = crew;
            $scope.model.showTrainingPassPanel = false;
            getTrainerTrainee();
            getTrainerTraineeCourses();
        };

        $scope.onUpdateTrainingDetails = function () {
            var flightStartDateTime = $scope.model.blockDetails.adaptedFlightEventDetails[0].startTime;
            var flightEndDateTiem = $scope.model.blockDetails.adaptedFlightEventDetails[$scope.model.blockDetails.adaptedFlightEventDetails.length - 1].endTime;
            if (moment(flightStartDateTime, "DD/MM/YYYY HH:mm").isBefore(moment($scope.model.blockDetails.checkInDateStr + " " + $scope.model.blockDetails.checkInTimeStr, "DD/MM/YYYY HH:mm"))) {
                MessageService.warning(MessageService.MESSAGES.CREWING.EDIT_BLOCK_ERROR_01);
                return false;
            }
            else if (moment($scope.model.blockDetails.checkoutDateStr + " " + $scope.model.blockDetails.checkoutTimeStr, "DD/MM/YYYY HH:mm").isBefore(moment(flightEndDateTiem, "DD/MM/YYYY HH:mm"))) {
                MessageService.warning(MessageService.MESSAGES.CREWING.EDIT_BLOCK_ERROR_02);
                return false;
            }
            else {
              var continueOveride = false;
            	updateTrainingDetails(continueOveride);
            }


        };

        $scope.upDateTrainerTrainee = function () {

        	setTrainingCheckingTimes();
        	if($scope.model.selectedCrewRole != null && $scope.model.selectedCrewRole.trainerTypeCode == 'TNE' && $scope.model.selectedFlightLegId === null) {
        		updateCheckInTime(false);
        	} else {
            upDateTrainerTrainee();
        	}
        };


        $scope.onTrainingChange = function () {
            getTrainingProgramDetails();
        };

        $scope.selectCrewCheckBox = function (crew) {
          if(!isExistInList(crew) && crew.isSelected){
            $scope.model.selectedCrewList.push(crew);
          }else if(!crew.isSelected){
            removeElementFromCrewList(crew);
          }

          if(!isExistInProfileList(crew.crewProfileId) && crew.isSelected){
            $scope.model.crewProfileIds.push(crew.crewProfileId);
            $scope.model.crewIds.push(crew.crewId);
            var hubCode = crew.otherHub || crew.crewHub || null;
            $scope.model.crewHubs.push(hubCode);
          }else if(!crew.isSelected){
            removeElementFromCrewProfileList(crew.crewProfileId);
            removeElementFromCrewIdList(crew.crewId);
            var hubCode = crew.otherHub || crew.crewHub || null;
            removeElementFromCrewHubList(hubCode);
          }
        }

      function isExistInList(crew){
        return ($scope.model.selectedCrewList.indexOf(crew) >= 0) ? true : false;
      }

      function removeElementFromCrewList(crew){
        if(isExistInList(crew)){
          $scope.model.selectedCrewList.splice($scope.model.selectedCrewList.indexOf(crew), 1);
        }
      }

      function getSelectedCrewList(){
        var list = [];
        angular.forEach($scope.model.selectedCrewList, function(crew){
          if (crew.trainrerTraineeTypeCode === 'TNE') {
            list.push(_.find($scope.model.blockDetails.assignedCrewDetailDTOs, {crewProfileId: crew.crewProfileId}));
          }
        });

        if(list.length == 0){
          if ($scope.model.selectedCrew.trainrerTraineeTypeCode === 'TNE') {
            list.push($scope.model.selectedCrew);
          }
        }
        return list;
      }

      function isExistInProfileList(crewProfileId){
        return ($scope.model.crewProfileIds.indexOf(crewProfileId) >= 0) ? true : false;
      }

      function removeElementFromCrewProfileList(crewProfileId){
        $scope.model.crewProfileIds.splice($scope.model.crewProfileIds.indexOf(crewProfileId), 1);
      }

      function removeElementFromCrewIdList(crewId){
        $scope.model.crewIds.splice($scope.model.crewIds.indexOf(crewId), 1);
      }

      function removeElementFromCrewHubList(crewHub){
        $scope.model.crewHubs.splice($scope.model.crewHubs.indexOf(crewHub), 1);
      }
        $scope.updateResult = function (scope) {
            if (scope.passFailForm.$valid && !!$scope.model.selectedResult) {
                var crewList = getSelectedCrewList();
                if ($scope.model.blockDetails.isTraining) {
                    var selectedTraining = _.find($scope.model.blockDetails.scheduleTrainingDetails, {trainingSlotId: $scope.model.selectedTrainingSlotId});
                    CrewingHelper.updateExpiryBlock(
                        selectedTraining,
                        crewList,
                        $scope.model.selectedResult && $scope.model.selectedResult.name,
                        $scope.model.remarks,$scope.model.validationNo,
                        function (updateResponse) {
                            if (updateResponse.success) {
                                $scope.model.selectedCrewList = [];
                                MessageService.success('Result successfully updated');
                                EventManagerService.notifyEventListeners(EventManagerService.EVENT.PANEL.RELOAD_PANEL_DATA, _panelName);
                                // Check for other hub crew warnings/failures
                                handleOtherHubCrewResults(updateResponse);
                            } else {
                                $scope.model.selectedCrewList = [];
                                MessageService.error('Update operation unsuccessful');
                            }
                        },
                        function (msg) {
                            $scope.model.selectedCrewList = [];
                            MessageService.error(msg);
                        }
                    );
                } else {
                    var selectedFlight = _.find($scope.model.blockDetails.scheduleFlightLegDetails, {flightLegId: $scope.model.selectedFlightLegId});
                    updateFlightExpiryWithWarningHandling(selectedFlight, crewList, null);
                }
            }
        };

        /**
         * Update flight expiry with warning handling and retry capability
         */
        function updateFlightExpiryWithWarningHandling(selectedFlight, crewList, ignoreFlags) {
            // Determine if we have local hub crews in the request
            var hasLocalHubCrews = crewList.some(function(crew) {
                return !crew.otherHub;
            });
            var hasOtherHubCrews = crewList.some(function(crew) {
                return !!crew.otherHub;
            });

            CrewingHelper.updateExpiryFlight(
                selectedFlight,
                crewList,
                $scope.model.selectedResult && $scope.model.selectedResult.name,
                $scope.model.remarks,
                $scope.model.validationNo,
                function (updateResponse) {
                    if (updateResponse.success) {
                        $scope.model.selectedCrewList = [];
                        // Show success message only for local hub crews
                        if (hasLocalHubCrews) {
                            MessageService.success('Result successfully updated');
                        }
                        // Check for other hub crew results - pass context for proper messaging
                        handleOtherHubCrewResults(updateResponse, selectedFlight, !hasLocalHubCrews);
                    } else if (updateResponse.warnType) {
                        // Handle warning - show confirmation dialog
                        handleExpiryWarning(updateResponse, selectedFlight, crewList);
                    } else {
                        $scope.model.selectedCrewList = [];
                        MessageService.error('Update operation unsuccessful');
                    }
                },
                function (msg) {
                    MessageService.error(msg);
                },
                ignoreFlags
            );
        }

        /**
         * Handle expiry warning by showing confirmation dialog
         */
        function handleExpiryWarning(updateResponse, selectedFlight, crewList) {
            var warnType = updateResponse.warnType;
            var crewName = updateResponse.crewProfileName || 'Unknown Crew';
            var messages = [];
            var canRetry = true;

            if (warnType === 'EXPIRY_EXISTS') {
                messages = [
                    'An expiry record already exists for crew: ' + crewName,
                    'Do you want to override the existing expiry record?'
                ];
            } else if (warnType === 'EXPIRY_WARN_EXIST') {
                messages = [
                    'Expiry conflict detected for crew: ' + crewName,
                    'The new expiry date may conflict with an existing record.',
                    'Do you want to continue?'
                ];
            } else if (warnType === 'EXPIRY_DELETE_NO_PRIVILEGE') {
                messages = [
                    'You do not have privilege to modify expiry records for crew: ' + crewName
                ];
                canRetry = false;
            } else {
                messages = [
                    'Warning for crew: ' + crewName,
                    updateResponse.warnType,
                    'Do you want to continue?'
                ];
            }

            if (canRetry) {
                var param = {
                    title: 'Confirmation',
                    messages: messages
                };
                PopupManager.openModal('CONFIRM_DIALOG', param, function(result) {
                    if (result === 'YES') {
                        // Retry with ignore flags
                        var ignoreFlags = {
                            ignoreExpiry: true,
                            ignoreExpiryProcess: true,
                            ignoreObjectExpiryExists: true,
                            ignoreObjectExpiryProcess: true
                        };
                        updateFlightExpiryWithWarningHandling(selectedFlight, crewList, ignoreFlags);
                    } else {
                        $scope.model.selectedCrewList = [];
                        MessageService.warning('Update operation cancelled');
                    }
                });
            } else {
                $scope.model.selectedCrewList = [];
                MessageService.error(messages[0]);
            }
        }

       
        function handleOtherHubCrewResults(updateResponse, selectedFlight, onlyOtherHubCrews) {
            if (!updateResponse.otherHubCrewResults || updateResponse.otherHubCrewResults.length === 0) {
                // If only other hub crews were selected but no results, show generic success
                if (onlyOtherHubCrews) {
                    MessageService.success('Result successfully updated');
                }
                return;
            }

            var retryableCrews = [];
            var hardFailures = [];
            var successCount = 0;

            angular.forEach(updateResponse.otherHubCrewResults, function(result) {
                if (result.success) {
                    successCount++;
                } else {
                    var crewInfo = 'Crew ' + (result.crewId || 'Unknown') + ' (Hub: ' + (result.targetHub || 'Unknown') + ')';
                    
                    if (result.errorCode === 'EXPIRY_EXISTS' || result.errorCode === 'EXPIRY_WARN_EXIST') {
                        // Retryable warning - collect for confirmation dialog
                        retryableCrews.push({
                            crewId: result.crewId,
                            crewProfileId: result.crewProfileId,
                            targetHub: result.targetHub,
                            errorCode: result.errorCode,
                            message: result.errorCode === 'EXPIRY_EXISTS' 
                                ? crewInfo + ': Expiry record already exists'
                                : crewInfo + ': Expiry conflict detected'
                        });
                    } else if (result.errorCode === 'EXPIRY_DELETE_NO_PRIVILEGE') {
                        hardFailures.push(crewInfo + ': No privilege to delete expiry record.');
                    } else if (result.errorCode === 'GRPC_ERROR') {
                        hardFailures.push('CES-500: System error occurred. Please contact administrator.');
                    } else {
                        hardFailures.push(crewInfo + ': ' + (result.message || 'Update failed.'));
                    }
                }
            });

            // Show success count if any succeeded
            if (successCount > 0) {
                MessageService.success(successCount + ' other hub crew(s) updated successfully.');
            }

            // Show hard failures (non-retryable)
            if (hardFailures.length > 0) {
                angular.forEach(hardFailures, function(failure) {
                    MessageService.error(failure);
                });
            }

            // Show confirmation dialog for retryable warnings
            if (retryableCrews.length > 0) {
                showOtherHubRetryConfirmation(retryableCrews, selectedFlight);
            }
        }


        function showOtherHubRetryConfirmation(retryableCrews, selectedFlight) {
            var messages = ['The following other hub crews have warnings:'];
            
            angular.forEach(retryableCrews, function(crew) {
                messages.push(crew.message);
            });
            
            messages.push('');
            messages.push('Do you want to override and continue?');

            var param = {
                title: 'Other Hub Crew Confirmation',
                messages: messages
            };

            PopupManager.openModal('CONFIRM_DIALOG', param, function(result) {
                if (result === 'YES') {
                    retryOtherHubCrewsUpdate(retryableCrews, selectedFlight);
                } else {
                    MessageService.warning('Update cancelled for ' + retryableCrews.length + ' other hub crew(s).');
                }
            });
        }

 
        function retryOtherHubCrewsUpdate(retryableCrews, selectedFlight) {
            // Build crew list with only the failed other hub crews
            var crewList = [];
            angular.forEach(retryableCrews, function(crew) {
                // Find the crew in assignedCrewTrainingDetails to get full info
                var crewDetail = _.find(selectedFlight.assignedCrewTrainingDetails, function(item) {
                    return item.crewId === crew.crewId || 
                           (item.crewProfileId && item.crewProfileId.toString() === crew.crewProfileId.toString());
                });
                
                if (crewDetail) {
                    crewList.push({
                        crewProfileId: crewDetail.crewProfileId,
                        crewId: crew.crewId,
                        otherHub: crew.targetHub
                    });
                }
            });

            if (crewList.length === 0) {
                MessageService.error('Could not find crew details for retry.');
                return;
            }

            // Call the same endpoint with ignoreExpiry=true
            var ignoreFlags = {
                ignoreExpiry: true,
                ignoreExpiryProcess: true,
                ignoreObjectExpiryExists: true,
                ignoreObjectExpiryProcess: true
            };

            CrewingHelper.updateExpiryFlight(
                selectedFlight,
                crewList,
                $scope.model.selectedResult && $scope.model.selectedResult.name,
                $scope.model.remarks,
                $scope.model.validationNo,
                function(retryResponse) {
                    if (retryResponse.success) {
                        MessageService.success('Other hub crew(s) updated successfully.');
                        // Check if there are still any failures in retry
                        if (retryResponse.otherHubCrewResults) {
                            var stillFailed = retryResponse.otherHubCrewResults.filter(function(r) { 
                                return !r.success; 
                            });
                            if (stillFailed.length > 0) {
                                angular.forEach(stillFailed, function(f) {
                                    MessageService.error('Crew ' + f.crewId + ' (Hub: ' + f.targetHub + '): ' + (f.message || 'Update failed'));
                                });
                            }
                        }
                    } else {
                        MessageService.error('Retry failed: ' + (retryResponse.message || 'Unknown error'));
                    }
                },
                function(msg) {
                    MessageService.error('Retry failed: ' + msg);
                },
                ignoreFlags
            );
        }

        function upDateTrainerTrainee(){
        	 var crew = _.find($scope.model.blockDetails.assignedCrewDetailDTOs, {crewProfileId: $scope.model.selectedCrewProfileId});

            var selectedFlights = [];
            if (!$scope.model.blockDetails.isTraining) {
              selectedFlights.push($scope.model.selectedFlightLegId);
            }
            var selectedTrainingSlots = [];
            selectedTrainingSlots.push($scope.model.selectedTrainingSlotId);
            var selectedCrewShedTrainingSlots = [];
            selectedCrewShedTrainingSlots.push(crew.crewSchdTrainingSlotId);
             var param = {
                 trainingProgramId: $scope.model.selectedTrainingProgram.trainingProgramId,
                 trainingProgramDetailId: $scope.model.selectedTrainingProgramDetails.trainingProgramDetailId,
                 trainingSlotId: $scope.model.selectedTrainingSlotId,
                 crewProfileId: $scope.model.selectedCrewProfileId,
                 crewHub: crew.crewHub,
                 crewId: crew.crewId,
                 type: $scope.model.blockDetails.isTraining ? 'SLOT' : 'FLIGHT',
                 assignedAsType: $scope.model.selectedCrewRole != null ? $scope.model.selectedCrewRole.trainerTypeCode : null,
                 assignedAsCourse:$scope.model.selectedCourse != null ? $scope.model.selectedCourse.courseId : null,
                 crewScheduleBlockId: $scope.model.blockDetails.crewScheduleBlockId,
                 version: getVersion(crew),
                 crewScheduleTrainingSlotId: getSlotId(crew),
                 crewSchdFlightLegId: crew && crew.crewSchdFlightLegId,
                 selectedFlightLegId: $scope.model.selectedFlightLegId,
                 isTraining: $scope.model.blockDetails.isTraining,
                 courseStartDate : $scope.model.blockDetails.checkInDateStr,
                 courseStartTime : $scope.model.blockDetails.checkInTimeStr,
                 crewProfileIds : $scope.model.crewProfileIds,
                 crewIds : $scope.model.crewIds,
                 crewHubs : $scope.model.crewHubs,
                 selectedFlightLegIds : $scope.model.selectedFlightLegIdList.length > 0 ? $scope.model.selectedFlightLegIdList :selectedFlights,
                 selectedCrewSchedTrainingSlotIds : selectedCrewShedTrainingSlots
             };
             CrewingHelper.updateTrainerTrainee(param,
                 function (response) {
                     if (response.success) {
                         crew.trainrerTraineeType = ($scope.model.selectedCrewRole && $scope.model.selectedCrewRole.trainerTypeDesc) || null;
                         EventManagerService.notifyEventListeners(EventManagerService.EVENT.PANEL.RELOAD_PANEL_DATA, _panelName);
                         MessageService.success(MessageService.MESSAGES.CREWING.TRAINING_DETAILS_UPDATE_SUCCESS);
                     }
                   $scope.model.crewProfileIds = [];
                   crew.trainrerTraineeType = $scope.model.selectedCrewRole.trainerTypeDesc;
                   crew.trainrerTraineeTypeCode = $scope.model.selectedCrewRole.trainerTypeCode;
                   $scope.onCrewClick($scope.model.selectedCrewProfileId, crew);
                   $scope.model.crewIds = [];
                   $scope.model.crewHubs = [];
                 },
                 function (msg) {
                     MessageService.error(msg);
                 }
             );
        }

        function updateTrainingDetails(continueOveride){
        	if (!!$scope.model.selectedTrainingProgram){
                if(!$scope.model.selectedTrainingProgramDetails){
                    MessageService.warning('Program Detail cannot be blank.');
                    return false;
                }
            }

            var crewSchdBlockId = $scope.model.blockDetails.crewScheduleBlockId;
            var type = $scope.model.blockDetails.isTraining ? 'SLOT' : 'FLIGHT';
            var slotId = $scope.model.blockDetails.isTraining ? $scope.model.selectedTrainingSlotId : $scope.model.selectedFlightLegId;
            var selected;
            if ($scope.model.blockDetails.isTraining) {
                selected = _.find($scope.model.blockDetails.scheduleTrainingDetails, {trainingSlotId: $scope.model.selectedTrainingSlotId});
            } else {
                selected = _.find($scope.model.blockDetails.scheduleFlightLegDetails, {flightLegId: $scope.model.selectedFlightLegId});
            }
            var version = !!selected ? selected.version : 0;
            var selectedFlightLegIdList = $scope.model.selectedFlightLegIdList;

            CrewingHelper.updateTrainingProgram(
                $scope.model.blockDetails.blockId,
                $scope.model.blockDetails.crewProfileId,
                continueOveride,
                $scope.model.selectedPic == 'Y' ? 'Y' : 'N',
                crewSchdBlockId,
                type,
                slotId,
                ($scope.model.selectedTrainingProgram && $scope.model.selectedTrainingProgram.trainingProgramId) || null,
                ($scope.model.selectedTrainingProgramDetails && $scope.model.selectedTrainingProgramDetails.trainingProgramDetailId) || null,
                version,
                function (updateResponse) {
                    if (updateResponse.success) {
                        MessageService.success(MessageService.MESSAGES.CREWING.UPDATE_SUCCESS);
                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.PANEL.RELOAD_PANEL_DATA, _panelName);
                    } else {
                        MessageService.error(MessageService.MESSAGES.CREWING.UPDATE_FAIL);
                    }
                },
                function (msg) {
                    MessageService.error(msg);
                },
              selectedFlightLegIdList);
        }

        function updateCheckInTime(isContinueIllegal) {
            $scope.model.blockDetails.continueIllegal = isContinueIllegal;

            if($scope.model.checkInDateStr != null && $scope.model.checkInTimeStr != null){
            	$scope.model.blockDetails.checkInDateStr = $scope.model.checkInDateStr;
            	$scope.model.blockDetails.checkInTimeStr = $scope.model.checkInTimeStr;
            }

            CrewingHelper.updateCheckInCheckout($scope.model.blockDetails,
                function (res) {
            		editBlockTimeResponseAction(res);
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        }

        function editBlockTimeResponseAction(editParingResponse) {
            if (editParingResponse.success) {
            	upDateTrainerTrainee();
                var updated = CrewingHelper.getCrewIdsFromBlockDetails($scope.model.blockDetails);
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.TOOLBAR.CREWING.UPDATE_SCHEDULE_FOR_CREWS, updated);
                SlideInPanelService.toggle(_panelName, $scope.model.blockDetails);
            } else if (!!editParingResponse) {
                if (!!editParingResponse.regulationMap) {
                    var regulationDetailParam = {
                        regulationMap: editParingResponse.adaptedRegulationMap,
                        onAcceptPassBackParam: editParingResponse
                    };
                    PopupManager.openModal('REGULATION_DETAILS', regulationDetailParam, closeRegulationPopupForPairing);
                }
            }
        }

        function closeRegulationPopupForPairing(params) {
            if (!!params) {
            	updateCheckInTime(true);
            }
        }

        function setTrainingCheckingTimes(){

        	if($scope.model.selectedTrainingProgram == null ){
            	$scope.model.checkInDateStr = null;
    	        $scope.model.checkInTimeStr = null;
    	        return;
            }

	        var checkInDate = moment($scope.model.blockDetails.actualBlockStartDate + " " +$scope.model.blockDetails.actualBlockStartTime,
    		"DD/MM/YYYY HH:mm")

	        checkInDate.add( ( -1 * $scope.model.selectedTrainingProgram.defaultCheckIn ), 'minutes');

	        var checkInDateStr = checkInDate.format('DD/MM/YYYY');
	        var checkInTimeStr = checkInDate.format('HH:mm');
	        $scope.model.checkInDateStr = checkInDateStr;
	        $scope.model.checkInTimeStr = checkInTimeStr;

        }

        function getVersion(crew) {
            var version = null;
            if (!!crew) {
                version = ($scope.model.blockDetails.isTraining) ? crew.crewSchdTrainingSlotVersion : crew.crewSchdFlightLegVersion;
            }
            return version;
        }

        function getSlotId(crew) {
            var slot = null;
            if (!!crew) {
                slot = ($scope.model.blockDetails.isTraining) ? crew.crewSchdTrainingSlotId : crew.crewSchdFlightLegId;
            }
            return slot;
        }

        function onUpdate(isContinueIllegal) {
            $scope.model.blockDetails.continueIllegal = isContinueIllegal;
            CrewingHelper.updateCheckInCheckout($scope.model.blockDetails,
                function (res) {
                    editPairingResponseAction(res);
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        }

        function setPassFailInfo() {
            var selected;
            if ($scope.model.blockDetails.isTraining) {
                selected = _.find($scope.model.blockDetails.scheduleTrainingDetails, {trainingSlotId: $scope.model.selectedTrainingSlotId});
            } else {
                selected = _.find($scope.model.blockDetails.scheduleFlightLegDetails, {flightLegId: $scope.model.selectedFlightLegId});
            }

            if (!!selected) {
                $scope.model.isExpiryUpdatable = selected.expiryUpdatable;
                var crew = _.find(selected.assignedCrewTrainingDetails, {crewProfileId: $scope.model.selectedCrewProfileId});
                if (!!crew && crew.result) {
                    $scope.model.selectedResult = {name: crew.result};
                    $scope.model.remarks = crew.remarks;
                    $scope.model.validationNo = crew.validationNo;
                } else {
                    $scope.model.selectedResult = null;
                  $scope.model.remarks = null;
                  $scope.model.validationNo = null;
                }
            } else {
                $scope.model.selectedResult = null;
                $scope.model.remarks = null;
                $scope.model.validationNo = null;
            }
        }

        function setRoleForSelectedCrew() {
            var crew = _.find($scope.model.blockDetails.assignedCrewDetailDTOs, {crewProfileId: $scope.model.selectedCrewProfileId});
            if (!!crew && !!crew.trainrerTraineeType) {
                $scope.model.selectedCrewRole = _.find($scope.model.crewRoleCol, {trainerTypeCode: crew.trainrerTraineeTypeCode});
                if(crew.trainrerTraineeTypeCode == 'TNE') {
                  $scope.model.showTrainingPassPanel = true;
                  setPassFailInfo();
                }
            } else {
                $scope.model.selectedCrewRole = null;
            }
        }

        function getTrainerTrainee() {
          if ($scope.model.selectedTrainingSlotId == null) {
            $scope.model.selectedTrainingSlotId = 0;
          }
          if ($scope.model.trainingStartDate == null) {
            $scope.model.trainingStartDate = "FLIGHT";
          }
            if (!!$scope.model.selectedCrewProfileId && !!$scope.model.selectedTrainingProgram && $scope.model.selectedTrainingProgram.trainingProgramId)
              var startDate = $scope.model.trainingStartDate.toString().replace("/","-").replace("/","-");
              CommonMasterData.getTrainerTraineeTypes(
                    $scope.model.selectedCrewProfileId,
                    $scope.model.selectedTrainingProgram.trainingProgramId,
                    $scope.model.selectedTrainingSlotId,
                    startDate,
                    $scope.model.selectedCrewId,
                    function (types) {
                        $scope.model.crewRoleCol = types;
                        setRoleForSelectedCrew();
                    },
                    function (error) {
                        MessageService.error(error);
                    }
                )
        }


        function editPairingResponseAction(editParingResponse) {
            if (editParingResponse.success) {
                MessageService.success(MessageService.MESSAGES.CREWING.UPDATE_SUCCESS);
                if (editParingResponse.otherBlockIllegal) {
                    MessageService.warning(MessageService.MESSAGES.CREWING.ASSIGN_TRAINING_OTHER_BLOCKS_ILLEGAL);
                }
                var updated = CrewingHelper.getCrewIdsFromBlockDetails($scope.model.blockDetails);
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.TOOLBAR.CREWING.UPDATE_SCHEDULE_FOR_CREWS, updated);
                SlideInPanelService.toggle(_panelName, $scope.model.blockDetails);
            } else if (!!editParingResponse) {
                if (!!editParingResponse.regulationMap) {
                    var regulationDetailParam = {
                        regulationMap: editParingResponse.adaptedRegulationMap,
                        onAcceptPassBackParam: editParingResponse
                    };
                    PopupManager.openModal('REGULATION_DETAILS', regulationDetailParam, onCloseRegulationPopupForPairing);
                }
            }
        }

        function onCloseRegulationPopupForPairing(params) {
            if (!!params) {
                onUpdate(true);
            }
        }


        function resetPreviousTrainingCategoryInfo() {
            angular.forEach($scope.model.blockDetails.adaptedAssignedCrewDetails, function (crewColVal) {
                if (crewColVal.fieldName == 'Trainee/Trainer') {
                    crewColVal.fieldValues[0].field_0 = '';
                }
            });
        }

        function setTrainingCategoryForCrews() {
            resetPreviousTrainingCategoryInfo();
            var selectedFlight = _.find($scope.model.blockDetails.scheduleFlightLegDetails, {flightLegId: $scope.model.selectedFlightLegId});
            if (!!selectedFlight) {
                angular.forEach(selectedFlight.assignedCrewTrainingDetails, function (crew) {
                    var crewColVal = $scope.model.blockDetails.adaptedAssignedCrewDetails;
                    var tmp = _.find(crewColVal, function (c) {
                        return c.fieldName == 'Trainee/Trainer' && c.fieldValues[0].crewProfileId == crew.crewProfileId
                    });
                    if (!!tmp) {
                        tmp.fieldValues[0].field_0 = crew.trainingCategory;
                    }
                });
            }
        }

        function setSelectedTraining() {
            var selectedFlight = _.find($scope.model.blockDetails.scheduleFlightLegDetails, {flightLegId: $scope.model.selectedFlightLegId});
            if (!!selectedFlight) {
                $scope.model.selectedTrainingProgram = _.find($scope.model.trainingPrograms, {trainingProgramId: selectedFlight.trainingProgramId});
                $scope.model.selectedPic = selectedFlight.isPIC == 'Y' ? true : false;
                if (!!$scope.model.selectedTrainingProgram) {
                    getTrainingProgramDetails();
                } else {
                    $scope.model.selectedTrainingProgramDetails = null;
                }
            }
        }

        function getTrainings() {
            if ($scope.model.blockDetails.isTraining) {
                var selected = _.find($scope.model.blockDetails.scheduleTrainingDetails, {trainingSlotId: $scope.model.selectedTrainingSlotId});
                if (!!selected) {
                    $scope.model.trainingPrograms = [{
                        trainingProgCode: selected.trainingProgramCode,
                        trainingProgramId: selected.trainingProgramId,
                    }];
                    $scope.model.selectedTrainingProgram = $scope.model.trainingPrograms[0];
                    getTrainingProgramDetails();
                }
            } else {
                CrewingHelper.getTrainingProgramsByCategoryCode('FLT',
                    function (trainings) {
                        $scope.model.trainingPrograms = trainings;
                        setSelectedTraining();
                    },
                    function (msg) {
                        MessageService.error(msg);
                    }
                );
            }


        }

        function setSelectedTrainingProgramDetails() {
            var selected;
            if ($scope.model.blockDetails.isTraining) {
                selected = _.find($scope.model.blockDetails.scheduleTrainingDetails, {trainingSlotId: $scope.model.selectedTrainingSlotId});
            } else {
                selected = _.find($scope.model.blockDetails.scheduleFlightLegDetails, {flightLegId: $scope.model.selectedFlightLegId});
            }

            if (!!selected) {
                $scope.model.selectedTrainingProgramDetails = _.find($scope.model.trainingProgramDetails, {trainingProgramDetailId: selected.trainingProgramDetailId})
              if (!!$scope.model.selectedTrainingProgramDetails) {
                    $scope.model.isTrainerTraineeDisable = false;
                    if (!!$scope.model.selectedCrewProfileId) {
                        getTrainerTrainee();
                        getTrainerTraineeCourses();
                    }
                } else {
                    $scope.model.isTrainerTraineeDisable = true;
                }
            }
        }

        function getTrainingProgramDetails() {
            if (!!$scope.model.selectedTrainingProgram) {
                CommonMasterData.getTrainingProgramDetails($scope.model.selectedTrainingProgram,
                    function (programDetails) {
                        $scope.model.trainingProgramDetails = programDetails;
                        setSelectedTrainingProgramDetails();
                    },
                    function (msg) {
                        MessageService.error(msg);
                    })
            }else{
                $scope.model.selectedTrainingProgramDetails = null;
            }
        }

      function getTrainerTraineeCourses() {
        if (!!$scope.model.selectedCrewProfileId && !!$scope.model.selectedTrainingProgram && $scope.model.selectedTrainingProgram.trainingProgramId)
          CommonMasterData.getTrainerTraineeCourses(
            $scope.model.selectedCrewProfileId,
            $scope.model.selectedTrainingProgram.trainingProgramId,
            $scope.model.selectedCrewId,
            function (types) {
              $scope.model.allCourses = types;
              setCourseForSelectedCrew();
            },
            function (error) {
              MessageService.error(error);
            }
          )
      }

      function setCourseForSelectedCrew(){
        var crew = _.find($scope.model.blockDetails.assignedCrewDetailDTOs,{crewProfileId : $scope.model.selectedCrewProfileId});
        $scope.model.selectedCourse = null;
        if(!!crew && !!crew.trainrerTraineeType){
          $scope.model.selectedCourse = _.find($scope.model.allCourses,{courseId : crew.courseName});
        }
      }

    }
}());
